import 'regenerator-runtime/runtime';
import { put, call, takeEvery, takeLatest, all } from 'redux-saga/effects';
import {sendAjaxRequest} from 'helper/interceptors';
import {AppSettings} from '../constants';
import * as ItemRepairActionType from './constants';
import * as NotifyActionType from 'Notification/constants';

let API_URI = AppSettings.CURRENT_SITE_URI;
let api = 'api';

if (AppSettings.CURRENT_SITE_URI === AppSettings.SITE_ONE_SERVICE_URI) {
  API_URI = AppSettings.GLOBAL_API_URL;
  api = 'apiv1';
}

export function* getByIdAsync(action) {
  let result;

  if (api === 'apiv1') {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/item-repairs/${action.params}`, {});
  } else {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/item-repairs/${action.params}`, {});
  }

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: ItemRepairActionType.GET_ITEM_REPAIR_BY_ID_SUCCESS, data: result.data });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getProblemByIdAsync(action) {
  let result;

  if (api === 'apiv1') {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/problems/${action.params}`, {});
  } else {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/problems/${action.params}`, {});
  }

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: ItemRepairActionType.GET_PROBLEM_BY_ID_SUCCESS, data: result.data });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchItemAsync(action) {
  let result;
  if (api === 'apiv1') {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/item-repairs/search`, action.params);
  } else {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/item-repairs/search`, action.params);
  }

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ItemRepairActionType.SEARCH_ITEM_REPAIR_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
    if (action.callback) {action.callback();}
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchProblemAsync(action) {
  let result;
  if (api === 'apiv1') {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/problems/search`, action.params);
  } else {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/item-repairs/${action.params.itemRepairId}/problems`, action.params);
  }

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ItemRepairActionType.SEARCH_PROBLEM_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* createItemAsync(action) {
  let result;
  if (api === 'apiv1') {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/item-repairs`, action.params.data, 'POST');
  } else {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/item-repairs`, action.params.data, 'POST');
  }

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ItemRepairActionType.SEARCH_ITEM_REPAIR_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Item to repair created' })
    ];
    if (action.callback) {action.callback();}
  } else {
    yield put({ type: ItemRepairActionType.ADD_EDIT_ITEM_REPAIR_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* createProblemAsync(action) {
  let result;
  if (api === 'apiv1') {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/problems`, action.params.data, 'POST');
  } else {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/item-repairs/${action.params.id}/problems`, action.params.data, 'POST');
  }

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ItemRepairActionType.SEARCH_PROBLEM_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Problem created' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: ItemRepairActionType.ADD_EDIT_ITEM_REPAIR_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* updateItemAsync(action) {
  let result;
  if (api === 'apiv1') {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/item-repairs/${action.params.data.id}`, action.params.data, 'PUT');
  } else {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/item-repairs/${action.params.data.id}`, action.params.data, 'PUT');
  }

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ItemRepairActionType.SEARCH_ITEM_REPAIR_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.callback) {action.callback();}
  } else {
    yield put({ type: ItemRepairActionType.ADD_EDIT_ITEM_REPAIR_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* updateProblemAsync(action) {
  let result;
  if (api === 'apiv1') {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/problems/${action.params.data.id}`, action.params.data, 'PUT');
  } else {
    result = yield call(sendAjaxRequest, API_URI, `/${api}/problems/${action.params.data.id}`, {name: action.params.data.name}, 'PUT');
  }

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ItemRepairActionType.SEARCH_PROBLEM_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: ItemRepairActionType.ADD_EDIT_ITEM_REPAIR_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* makeActiveAsync(action) {
  const path = (API_URI === AppSettings.GLOBAL_API_URL) ? 'item-repairs' : 'item-repairs';
  const result = yield call(sendAjaxRequest, API_URI, `/${api}/${path}/${action.params.data}/active`, {}, 'PUT');

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ItemRepairActionType.SEARCH_ITEM_REPAIR_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: UserActionType.EDIT_USER_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* makeActiveProblemAsync(action) {

  const result = yield call(sendAjaxRequest, API_URI, `/${api}/problems/${action.params.data.id}/active`, {}, 'PUT');

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ItemRepairActionType.SEARCH_PROBLEM_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: UserActionType.EDIT_USER_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* makeInActiveAsync(action) {
  const path = (API_URI === AppSettings.GLOBAL_API_URL) ? 'item-repairs' : 'item-repairs';
  const result = yield call(sendAjaxRequest, API_URI, `/${api}/${path}/${action.params.data}/inactive`, {}, 'PUT');

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ItemRepairActionType.SEARCH_ITEM_REPAIR_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: UserActionType.EDIT_USER_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* makeInActiveProblemAsync(action) {

  const result = yield call(sendAjaxRequest, API_URI, `/${api}/problems/${action.params.data.id}/inactive`, {}, 'PUT');

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ItemRepairActionType.SEARCH_PROBLEM_ASYNC, params: action.params.search }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: UserActionType.EDIT_USER_ERROR, data: { error: result.data, params: action.params.data } });
  }
}

export function* selectListItemRepairAsync(action) {
  let result;
  if (api === 'apiv1') {
    result = yield call(sendAjaxRequest, API_URI, '/apiv1/item-repairs/select-list-items', action.params);
  } else {
    result = yield call(sendAjaxRequest, API_URI, '/api/item-repairs/selectListItems', action.params);
  }

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ItemRepairActionType.SELECT_LIST_ITEM_REPAIR_SUCCESS, data: result.data })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* selectListProblemAsync(action) {

  const result = yield call(sendAjaxRequest, API_URI, `/api/item-repairs/${action.params.id}/problem-select-list`, action.params, 'GET', false);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ItemRepairActionType.SELECT_LIST_PROBLEM_SUCCESS, data: result.data })
    ];
    if (action.callback) {action.callback(result.data);}
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}
export function* selectListBlueTapeProblemAsync(action) {

  const result = yield call(sendAjaxRequest, API_URI, `/api/item-repairs/${action.params.id}/problem-select-list`, action.params, 'GET', false);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: ItemRepairActionType.SELECT_LIST_BLUE_TAPE_PROBLEM_SUCCESS, data: result.data })
    ];
    if (action.callback) {action.callback(result.data);}
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export default function* WatchItemRepair() {
  yield all([
    takeLatest(ItemRepairActionType.SEARCH_ITEM_REPAIR_ASYNC, searchItemAsync),
    takeLatest(ItemRepairActionType.SEARCH_PROBLEM_ASYNC, searchProblemAsync),
    takeLatest(ItemRepairActionType.GET_ITEM_REPAIR_BY_ID_ASYNC, getByIdAsync),
    takeLatest(ItemRepairActionType.GET_PROBLEM_BY_ID_ASYNC, getProblemByIdAsync),
    takeEvery(ItemRepairActionType.CREATE_ITEM_REPAIR_ASYNC, createItemAsync),
    takeEvery(ItemRepairActionType.CREATE_PROBLEM_ASYNC, createProblemAsync),
    takeEvery(ItemRepairActionType.UPDATE_ITEM_REPAIR_ASYNC, updateItemAsync),
    takeEvery(ItemRepairActionType.UPDATE_PROBLEM_ASYNC, updateProblemAsync),
    takeEvery(ItemRepairActionType.MAKE_ACTIVE_ITEM_REPAIR_ASYNC, makeActiveAsync),
    takeEvery(ItemRepairActionType.MAKE_ACTIVE_PROBLEM_ASYNC, makeActiveProblemAsync),
    takeEvery(ItemRepairActionType.MAKE_INACTIVE_ITEM_REPAIR_ASYNC, makeInActiveAsync),
    takeEvery(ItemRepairActionType.MAKE_INACTIVE_PROBLEM_ASYNC, makeInActiveProblemAsync),
    takeLatest(ItemRepairActionType.SELECT_LIST_ITEM_REPAIR_ASYNC, selectListItemRepairAsync),
    takeLatest(ItemRepairActionType.SELECT_LIST_PROBLEM_ASYNC, selectListProblemAsync),
    takeLatest(ItemRepairActionType.SELECT_LIST_BLUE_TAPE_PROBLEM_ASYNC, selectListBlueTapeProblemAsync),

  ]);
}



// WEBPACK FOOTER //
// ./src/Items/saga.js